export interface CounterSpec {
  width: number;
  start: number;
  separator: string;
}

export const COUNTERS = {
  INC: { width: 7, start: 10484, separator: '' },
  PRB: { width: 7, start: 1205, separator: '' },
  CHG: { width: 7, start: 20146, separator: '' },
  CS: { width: 7, start: 1001, separator: '' },
  WO: { width: 4, start: 1, separator: '' },
  ACC: { width: 4, start: 1, separator: '' },
  CON: { width: 4, start: 1, separator: '' },
  CTR: { width: 4, start: 1, separator: '' },
  KB: { width: 7, start: 10013, separator: '' },
  CI: { width: 3, start: 11, separator: '' },
  AST: { width: 3, start: 7, separator: '' },
  AGT: { width: 3, start: 2, separator: '-' },
  AR: { width: 6, start: 1, separator: '' },
} as const satisfies Record<string, CounterSpec>;

export type CounterPrefix = keyof typeof COUNTERS;

export function formatRecordId(prefix: CounterPrefix, n: number): string {
  const spec = COUNTERS[prefix];
  return `${prefix}${spec.separator}${String(n).padStart(spec.width, '0')}`;
}
